/** @file A picked PNG file decoded under the upload caps, normalized and re-encoded for upload. */
import { decodePng } from '@pose2d/image-io/decodePng';
import { PNG_LIMITS } from '@pose2d/image-io/pngLimits.data';
import { encodeRgbaPng } from './encodeRgbaPng';
import type { PngLayer } from './importTypes';

/**
 * Any PNG the decoder reads (palette, 16-bit, grey, tRNS) becomes 8-bit straight RGBA; larger than 2048 px a side is
 * VALIDATION at `file` (the Worker would refuse it, spec §8.7). The name loses its `.png` suffix.
 */
export async function pngLayerFromFile(fileName: string, bytes: Uint8Array): Promise<PngLayer> {
  const image = decodePng(bytes, { ...PNG_LIMITS.upload, path: 'file' });
  return { name: fileName.replace(/\.png$/i, ''), png: await encodeRgbaPng(image), width: image.width, height: image.height };
}
